import React from "react";
import { Table } from "antd";
import { toNumberFormat } from "../../../utils/numberFormat";

const SummarySection = ({ mean, median, sd }) => {
  const getStatsCells = (data, prefix) => {
    return (
      <>
        <Table.Summary.Cell index={0}>{prefix}</Table.Summary.Cell>
        <Table.Summary.Cell index={1}>
          {toNumberFormat(data.freshMilkVolume)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2}>
          {toNumberFormat(data.flavoredMilkVolume)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3}>
          {toNumberFormat(data.totalMilkVolume)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4}>
          {toNumberFormat(data.soyMilkVolume)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}>
          {toNumberFormat(data.soyMilkSweetVolume)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6}>
          {toNumberFormat(data.cowMilkScore || data.totalCowMilkScore)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={7}>
          {toNumberFormat(
            data.vegetableQuantity || data.totalVegetableQuantity
          )}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={8}>
          {toNumberFormat(data.vegetableScore || data.totalVegetableScore)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={9}>
          {toNumberFormat(data.exerciseMinutes || data.totalExerciseMinutes)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={10}>
          {toNumberFormat(data.exerciseScore || data.totalExerciseScore)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={11}>
          {toNumberFormat(data.normalSweetDrinkVolume)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={12}>
          {toNumberFormat(data.lowSweetDrinkVolume)}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={13}>
          {toNumberFormat(data.sweetDrinkScore || data.totalSweetDrinkScore)}
        </Table.Summary.Cell>
      </>
    );
  };
  return (
    <>
      <Table.Summary.Row>{getStatsCells(mean, "ค่าเฉลี่ย")}</Table.Summary.Row>
      <Table.Summary.Row>
        {getStatsCells(sd, "ส่วนเบี่ยงเบน มาตรฐาน")}
      </Table.Summary.Row>
      <Table.Summary.Row>{getStatsCells(median, "มัธยฐาน")}</Table.Summary.Row>
    </>
  );
};

export default SummarySection;
